import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setPageTitle } from '../../redux/title/title.slice';
import { generateNavItems } from '../../lib/menuItems';
import SectionMenu from '../../components/SectionMenu';

export default function SystemAdmin() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);

  useEffect(() => {
    dispatch(setPageTitle('System Admin'));
  }, [dispatch]);

  const nav = generateNavItems(user);
  const section = nav.find((x) => x.title === 'System Admin');
  // Split groups
  const adminItems = section.items.slice(0, 5);

  return (
    <>
      <SectionMenu title={section.title} items={adminItems} />
    </>
  );
}
